import type { BcApiEndpoint } from '@/api/control/missionImpactAPI.schemas';
import { Badge } from '@/components/ui/badge';

interface BcApiEndpointBadgeProps {
  /** The BC API endpoint type to display. */
  endpoint: BcApiEndpoint;
}

/**
 * Displays a Business Central API endpoint variant (V2 or ODataV4) as an
 * outline badge, used to distinguish tables sourced from different BC APIs.
 */
export function BcApiEndpointBadge({ endpoint }: BcApiEndpointBadgeProps) {
  return <Badge variant="outline">{endpoint}</Badge>;
}
